/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react';
import styled from 'styled-components';
import TourHeaderDropdown from './TourHeaderDropdown';
import TourAutoSaveIndicator from './TourAutoSaveIndicator';
import TourInvitePendingBuyers from './TourInvitePendingBuyers';

const TourHeaderMenu: React.FC = () => (
    <StyledHeaderContainer>
      <TourInvitePendingBuyers />
      <TourAutoSaveIndicator />
      <TourHeaderDropdown />
    </StyledHeaderContainer>
  );

export default TourHeaderMenu;

const StyledHeaderContainer = styled.div`
  display: flex;
  align-items: center;
`;
